import { useEffect, useState } from "react"
import { restApiUri } from "../../constants";

const useAdmin = uid => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAdminLoading, setIsAdminLoading] = useState(true);
  useEffect(() => {
    if (uid) {
      fetch(`${restApiUri}/users/admin/${uid}`)
        .then(res => res.json())
        .then(data => {
          setIsAdmin(data.isAdmin)
          setIsAdminLoading(false);
        })
    }
  }, [uid])
  return [isAdmin, isAdminLoading]
}

export default useAdmin;